import { createContext, useState } from "react";

export const NotificationContext = createContext({
  notifications: null,
  showNotification: () => {},
});

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);

  const showNotification = (message) => {
    setNotifications(message);
    setTimeout(() => {
      setNotifications(null);
    }, 700);
  };
  const value = {
    notifications,
    showNotification,
  };
  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
}
